import mustache from "mustache";

window.Mustache = mustache;
